import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser';
import * as Constant from '../Constant'
import './home.css'
import axios from 'axios'

import { usePromiseTracker, trackPromise } from 'react-promise-tracker';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import Loader from 'react-loader-spinner';

import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Banner from '../Components/Banner';
import ListHorizontal from '../Components/DashboardListHorizontal';
import ListVertical from '../Components/DashboardListVertical';
import MitraPerusahaan from '../Components/MitraPerusahaan';

import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import OwlCarousel from 'react-owl-carousel';

import { css } from "@emotion/core";

import Cookies from 'universal-cookie';

// -----

// loading css
const override = css`
  display: block;
  margin: 0 auto;
  border-color: #3DADAA;
`;

const LoadingIndicator = () => {
    const { promiseInProgress } = usePromiseTracker();
    return (
        promiseInProgress &&
        <div style={{
            width: '100%',
            height: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '120px',
            zIndex: 100
        }}>
            <Loader type="Oval" color={'#ea6123'} height="100" width="100" />
        </div>
    )
}

const cookies = new Cookies();
class Home extends Component {
    // Adds a class constructor that assigns the initial state values:
    constructor() {
        super()
        this.state = {
            is_guest: false,
            user_id: null,
            banners: [],
            banner: '',
            banner_title: '',
            banner_desc: '',
            banner_button: '',
            categories: [],
            category_id: null,
            total_zakat: 0,
            total_donasi: 0,
            total_donatur: 0,

            donate_link: '/',
            go_donate_banner: false,
            go_zakat: false,
            go_donate: false,
            go_program: false,
            go_update: false,
            go_detail_program: false,
            go_detail_update: false,

            seo_key: '',

            link_youtube: '',
            programs: [],
            kisah_sukses: [],
            program_infaq: [],
            program_zakat: [],
            updateArtikel: [],
            slider: [],

            loading: true,
            content_loading: true,
            isAvailable: ''
        }

        this.timer = null
    }
    // This is called when an instance of a component is being created and inserted into the DOM.
    componentDidMount() {
        document.body.style.backgroundImage = "none"
        this.getId()
        if (cookies.get('id_yayasan') != null) {
            this.getContent()
        }
        // if (this.props.location.state) {
        //     console.log('baru', this.props.location.state.trigger)
        //     location.reload()
        // }
        // console.log(this.state.link_youtube != '')
        // if(this.state.link_youtube != ''){

        // }

 
    }
    componentWillUnmount() {
        document.removeEventListener('scroll', this.trackScrolling)
    }
    async askUserPermission() {
        return await Notification.requestPermission();
    }
    isPushNotificationSupported() {
        return "ServiceWorker" in navigator && "PushManager" in window;
    }
    getId() {
        if (cookies.get('id_yayasan') == null) {
            axios.get(Constant.GET_YAYASAN, {
                headers: {
                    'X-API-KEY': Constant.X_API_KEY
                }
            })
            .then(res => {
                var idc = res.data.data.id;
                cookies.set('id_yayasan', idc);
                // console.log('id_yayasn', cookies.get('id_yayasan'));
                this.getContent()
            })
        }
    }

    getDashboardBanner() {
        // get banner
        axios.get(Constant.GET_DASHBOARD_BANNER + cookies.get('id_yayasan'))
            .then(response => {
                // console.log(response.data)
                this.setState({
                    banners: response.data.data,
                    banner: Constant.GET_DASHBOARD_BANNER_SLIDER + response.data.data[0].id,
                    banner_title: response.data.data[0].judul,
                    banner_desc: response.data.data[0].deskripsi,
                    banner_button: response.data.data[0].title_button,
                    donate_link: response.data.data[0].link
                });
                // console.log('tes2', response.data.data);
            })
            // Catch any error here
            .catch(error => {
                console.log(error)
            })
    }
    getCategories() {
        // get categories
        axios.get(Constant.GET_CATEGORIES)
            .then(response => {
                // console.log(response.data)
                this.setState({ categories: response.data.data });
            })
            // Catch any error here
            .catch(error => {
                console.log(error)
            })
    }
    getStatistik() {
        //zakat
        axios.get(Constant.GET_TOTAL_ZAKAT)
            .then(response => {
                // console.log(response.data)
                this.setState({ total_zakat: response.data.total })
            })
            .catch(error => {
                console.log(error)
            })

        //donasi
        axios.get(Constant.GET_TOTAL_DONASI)
            .then(response => {
                // console.log(response.data)
                this.setState({ total_donasi: response.data.total })
            })
            .catch(error => {
                console.log(error)
            })

        //donatur
        axios.get(Constant.GET_TOTAL_DONATUR)
            .then(response => {
                // console.log(response.data)
                this.setState({ total_donatur: response.data.total })
            })
            .catch(error => {
                console.log(error)
            })
    }
    getContent() {
        trackPromise(
            axios.get(Constant.GET_DASHBOARD_CONTENT + cookies.get('id_yayasan'))
                .then(response => {
                    // console.log(response.data)
                    this.setState({
                        link_youtube: response.data.linkYoutube,
                        programs: response.data.program,
                        kisah_sukses: response.data.kisah_sukses,
                        program_infaq: response.data.program_infaq,
                        program_zakat: response.data.program_zakat,
                        updateArtikel: response.data.updateArtikel,
                        slider: response.data.slider
                    })

                    this.getDashboardBanner()
                    this.getCategories()
                    this.getStatistik()
                    if (response.data.length == 0) {
                        this.setState({
                            isAvailable: 'Tidak ada Konten, mohon periksa koneksi anda.'
                        })
                    }
                    this.setState({
                        loading: false,
                        content_loading: false,
                    })
                    this.infaqClicked()
                }).catch(error => {
                    console.log(error)
                })
        )
    }


    numberFormat(value) {
        return value.toLocaleString(navigator.language, { minimumFractionDigits: 0 }).replace(/\,/g, '.')
    }

    dateDiff(startDate, endDate) {
        startDate = new Date(startDate)
        endDate = new Date(endDate)
        return Math.floor((Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()) - Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate())) / (1000 * 60 * 60 * 24))
    }

    nFormatter(num, digits) {
        var si = [
            { value: 1, symbol: "" },
            { value: 1E3, symbol: "K" },
            { value: 1E6, symbol: "M" },
            { value: 1E9, symbol: "B" },
            { value: 1E12, symbol: "T" },
            { value: 1E15, symbol: "P" },
            { value: 1E18, symbol: "E" }
        ];
        var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        var i;
        for (i = si.length - 1; i > 0; i--) {
            if (num >= si[i].value) {
                break;
            }
        }
        return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
    }
    dateFormat(date) {
        if (date) {
            let days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jum`at', 'Sabtu']
            let months = [
                'Januari', 'Februari', 'Maret',
                'April', 'Mei', 'Juni', 'Juli',
                'Agustus', 'September', 'Oktober',
                'November', 'Desember'
            ]

            let new_date = new Date(date)
            let formatted_date = days[new_date.getDay()] + ", "
                + new_date.getDate() + " "
                + months[new_date.getMonth()] + " "
                + new_date.getFullYear()

            return formatted_date
        } else {
            return "Tanpa Batas Waktu"
        }
    }

    infaqClicked() {
        document.getElementById("tab-infaq").classList.add("item-tab-active");
        document.getElementById("tab-infaq").classList.remove("item-tab");
        document.getElementById("tab-zakat").classList.add("item-tab");
        document.getElementById("tab-zakat").classList.remove("item-tab-active");
        document.getElementById("infaq-scroller").classList.remove("hide");
        document.getElementById("zakat-scroller").classList.add("hide");
    }
    zakatClicked() {
        document.getElementById("tab-infaq").classList.add("item-tab");
        document.getElementById("tab-infaq").classList.remove("item-tab-active");
        document.getElementById("tab-zakat").classList.add("item-tab-active");
        document.getElementById("tab-zakat").classList.remove("item-tab");
        document.getElementById("zakat-scroller").classList.remove("hide");
        document.getElementById("infaq-scroller").classList.add("hide");
    }
    newTabClickedW() {
        let linkWhatsapp = window.open('https://api.whatsapp.com/send?phone=62816593922&text=Assalamualaikum%20Teman%20Peduli&source=&data=&app_absent=', '_blank')
        linkWhatsapp.focus()
    }
    // The render method contains the JSX code which will be compiled to HTML.
    render() {
        const {
            banners, banner, banner_title, banner_desc, banner_button,
            categories, category_id, go_donate_banner, donate_link,
            total_zakat, total_donasi, total_donatur, go_zakat, go_donate, seo_key, go_program, go_update, go_detail_program, go_detail_update,
            link_youtube, kisah_sukses, program_infaq, program_zakat, updateArtikel, programs, slider,
            content_loading, isAvailable
        } = this.state

        return (
            <div id="page">
                <Header />

                <LoadingIndicator />

                {content_loading === false &&
                    <>
                        <Banner slideData={slider} />
                        <div className="page-content">

                            <ListVertical title="Program" link="programs" data={programs} />
                            <ListHorizontal title="Update & Berita" numbers={1} link="update" data={updateArtikel} />

                            <MitraPerusahaan />
                        </div>
                    </>
                }
                <Footer />
            </div>
        )
    }
}

export default Home